export default __webpack_public_path__ + "media/images/map/marker_service_yellow-db96555b5d08453241a9f99e41610c86.png";